import React from "react";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./index.module.scss";

// The lockup's geometry in a 32-unit box centred on zero, so a rotation needs
// no transform-origin: eight dots 45 degrees apart from straight up, on a ring
// of 12.4, plus the centre, each of radius 3.6.
const RING = 12.4;
const DOT = 3.6;
const DOTS: readonly (readonly [number, number])[] = [
    ...Array.from({ length: 8 }, (_, i): readonly [number, number] => {
        const angle = ((-90 + i * 45) * Math.PI) / 180;
        return [Math.cos(angle) * RING, Math.sin(angle) * RING];
    }),
    [0, 0],
];

interface Props {
    className?: string;
    /** For a section that animates individual dots */
    dotClassName?: string;
}

/** thelab's nine-dot mark, in `currentColor`. Size it with CSS width. */
export const LogoMark = (props: Props) => (
    <svg
        className={concatClassNames([styles.root, props.className])}
        viewBox="-16 -16 32 32"
        aria-hidden="true"
    >
        {DOTS.map(([cx, cy], i) => (
            <circle
                key={i}
                className={props.dotClassName}
                cx={cx.toFixed(4)}
                cy={cy.toFixed(4)}
                r={DOT}
            />
        ))}
    </svg>
);
